import "./src/styles/global.css"
import "prismjs/themes/prism-tomorrow.css"
import type { GatsbyBrowser } from "gatsby"

// Run animations and scroll handler on every route change
export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = () => {
  // Animate elements with staggered reveal
  const animateElements = document.querySelectorAll(".animate")
  animateElements.forEach((element, index) => {
    element.classList.remove("show")
    setTimeout(() => {
      element.classList.add("show")
    }, index * 150)
  })

  // Scroll handler for header
  const header = document.getElementById("header")
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 0) {
        header.classList.add("scrolled")
      } else {
        header.classList.remove("scrolled")
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    onScroll()
  }

  // Carbon-style code block wrappers
  requestAnimationFrame(() => {
    const codeBlocks = document.querySelectorAll("article pre > code")
    codeBlocks.forEach((block) => {
      const pre = block.parentElement
      if (!pre || pre.parentElement?.classList.contains("code-block-wrapper")) return

      // Extract language from class like "language-bash"
      const langClass = Array.from(block.classList).find((c) => c.startsWith("language-"))
      const lang = langClass ? langClass.replace("language-", "") : ""

      // Create wrapper
      const wrapper = document.createElement("div")
      wrapper.className = "code-block-wrapper"

      // Create header with language label and copy button
      const header = document.createElement("div")
      header.className = "code-block-header"

      const langLabel = document.createElement("span")
      langLabel.className = "code-lang"
      langLabel.textContent = lang

      const copyBtn = document.createElement("button")
      copyBtn.className = "copy-btn"
      copyBtn.setAttribute("aria-label", "Copy code")
      copyBtn.innerHTML = `<svg class="copy-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>`

      copyBtn.addEventListener("click", () => {
        const text = block.textContent || ""
        navigator.clipboard.writeText(text).then(() => {
          copyBtn.innerHTML = `<svg class="copy-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`
          setTimeout(() => {
            copyBtn.innerHTML = `<svg class="copy-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>`
          }, 2000)
        })
      })

      header.appendChild(langLabel)
      header.appendChild(copyBtn)

      // Wrap the pre element
      pre.parentNode!.insertBefore(wrapper, pre)
      wrapper.appendChild(header)
      wrapper.appendChild(pre)
    })
  })
}
